module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./DetailView.js"));
	}, "NameDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NameDetailView!./src/pages/Promote/BusinessHall/AlterName/Detail/DetailView.js
// module id = 1142
// module chunks = 431